import typography from './typography';
import shadows from 'styles/shadows';
import componentThemeStyleOverrides from 'styles/componentThemeStyleOverrides';

export default {
  typography,
  shadows,
  components: componentThemeStyleOverrides,
  zIndex: {
    surface: 1,
    loader: 1150,
    max: 1600,
  },
};
